module.exports = __webpack_public_path__ + "static/media/Ashmayu_Full_W.aba5d6d7.png";